/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { tv } from 'tailwind-variants';
// Local
import { withStandardComponentWrapper } from 'helpers/HOC';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { getTestProps } from 'lib/testing/utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const ServiceBanner = (props)=>{
    const isEditing = useIsEditing();
    const { DynamicPlaceholderId, RenderingIdentifier } = props?.params || {};
    const phKey = `servicebanner-${DynamicPlaceholderId}`;
    const { base, item } = TAILWIND_VARIANTS();
    return /*#__PURE__*/ _jsx("section", {
        "data-component": "authorable/shared/lists/servicebanner",
        ...editingHydrationProps(isEditing),
        id: RenderingIdentifier,
        ...getTestProps(`component-servicebanner-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
            name: phKey,
            rendering: props.rendering,
            render: (components)=>/*#__PURE__*/ _jsx("ul", {
                    className: base(),
                    "aria-label": "Service banners",
                    children: components.map((comp, index)=>/*#__PURE__*/ _jsx("li", {
                            className: item(),
                            role: "listitem",
                            ...getTestProps(`banner-${index}`),
                            children: comp
                        }, index))
                })
        })
    });
};
export const Default = withStandardComponentWrapper(ServiceBanner, false);
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'gap-layout-base-gutter',
            'grid',
            'grid-cols-1',
            'md:grid-cols-2',
            'lg:grid-cols-4',
            'items-stretch'
        ],
        item: [
            'flex',
            'flex-col'
        ]
    }
});
